module.exports = __webpack_public_path__ + "static/media/CT_2019_30443_2015_pdf.359d0358.pdf";